import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Space, Typography } from "antd";
import { toast } from "../toasts/toastStore";
import { UserOutlined, LockOutlined, WarningOutlined } from "@ant-design/icons";
import axios from "axios";
import { PATH } from "../../redux/utils";
import { sessionManager } from "../../redux/sessionManager";
import { performLogout } from "../../utils/logout";

const { Title, Text } = Typography;

export default function ModalReautenticar({ open, onClose }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ usuario: localStorage.getItem("usuario") || "" });
    }
  }, [open, form]);

  const handleSubmit = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.post(
        `${PATH}/auth/login`,
        { usuario: values.usuario, password: values.password },
        { headers: { "Content-Type": "application/json" } }
      );

      const token = data?.access_token;
      if (!token) throw new Error("Respuesta invalida del servidor");

      localStorage.setItem("token", token);
      localStorage.setItem("usuario", values.usuario);
      if (data?.role) localStorage.setItem("role", data.role);

      sessionManager.onAuthSuccess(token);
      window.dispatchEvent(new Event("permisos-refresh"));
      form.resetFields();
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Usuario o contrasena incorrectos";
      toast.error(msg || "Error al autenticar");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    sessionManager.onAuthFailure();
    performLogout();
  };

  return (
    <Modal
      open={open}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={440}
      footer={null}
    >
      <div style={{ padding: "8px 4px 16px" }}>
        <Space size={12} align="center">
          <WarningOutlined style={{ fontSize: 20, color: "#dc2626" }} />
          <div>
            <Title level={4} style={{ margin: 0, lineHeight: 1.2 }}>
              Sesion expirada
            </Title>
            <Text type="secondary">Vuelve a iniciar sesion para continuar.</Text>
          </div>
        </Space>

        <Form form={form} layout="vertical" requiredMark="optional" onFinish={handleSubmit} style={{ marginTop: 18 }}>
          <Form.Item
            label="Usuario"
            name="usuario"
            rules={[{ required: true, message: "El usuario es obligatorio." }]}
          >
            <Input size="large" prefix={<UserOutlined />} disabled={loading} />
          </Form.Item>

          <Form.Item
            label="Contrasena"
            name="password"
            rules={[{ required: true, message: "La contrasena es obligatoria." }]}
          >
            <Input.Password size="large" prefix={<LockOutlined />} disabled={loading} autoFocus />
          </Form.Item>

          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            <Button danger onClick={handleLogout} disabled={loading}>
              Cerrar sesion
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ background: "#f90336", borderColor: "#f90336" }}
            >
              Iniciar sesion
            </Button>
          </Space>
        </Form>
      </div>
    </Modal>
  );
}
